(() => {
  const selector = '[data-product-card-label-scheduled]';
  const timezonePattern = /(Z|[+-]\d{2}:\d{2})$/i;

  const parseBoundary = (value) => {
    const normalizedValue = (value || '').trim();
    if (!normalizedValue) return { present: false, valid: true, timestamp: null };
    if (!timezonePattern.test(normalizedValue)) return { present: true, valid: false, timestamp: null };

    const timestamp = Date.parse(normalizedValue);
    return {
      present: true,
      valid: Number.isFinite(timestamp),
      timestamp
    };
  };

  const evaluateLabel = (label, now = Date.now()) => {
    const start = parseBoundary(label.dataset.scheduleStart);
    const end = parseBoundary(label.dataset.scheduleEnd);
    const hasBoundary = start.present || end.present;
    const validSchedule = hasBoundary && start.valid && end.valid &&
      (!start.present || !end.present || end.timestamp > start.timestamp);

    const isActive = validSchedule &&
      (!start.present || now >= start.timestamp) &&
      (!end.present || now < end.timestamp);

    label.hidden = !isActive;
    label.toggleAttribute('data-schedule-invalid', !validSchedule);
  };

  const evaluateAllLabels = (root = document) => {
    const now = Date.now();
    root.querySelectorAll(selector).forEach((label) => evaluateLabel(label, now));
  };

  const initialize = () => {
    evaluateAllLabels();

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches(selector)) evaluateLabel(node);
          evaluateAllLabels(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setInterval(() => evaluateAllLabels(), 60000);
    document.addEventListener('shopify:section:load', (event) => evaluateAllLabels(event.target));
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) evaluateAllLabels();
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
